import { fetchToken } from "../../../common/FetchCookie";

const API = "https://api.indiahirings.com/api/profile/change-password"


export const ChangePassword = async ({ current_password, password, password_confirmation }) => {
  try {
    const token = await fetchToken()

    const response = await fetch(`${API}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify({ current_password, password, password_confirmation }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Failed to reset password");
    }

    return data;
  } catch (error) {
    throw new Error(error.message);
  }
};
